import { Skeleton } from "@material-ui/lab";
import { animated, useSpring } from "@react-spring/web";
import React, { useEffect } from "react";
import { loadingMessages } from "../../constants";

export const AILoadingMessages = ({ index }: { index?: number }) => {
  const messageIndex = index ? index : Math.floor(Math.random() * loadingMessages.length);
  const [emptyMessageContainer, emptyMessageContainerApi] = useSpring(() => ({
    from: { opacity: 0 },
  }));

  const [contentDelay, contentDelayApi] = useSpring(() => ({
    from: { opacity: 0 },
  }));

  useEffect(() => {
    emptyMessageContainerApi.start({ to: { opacity: 1 }, delay: 250 });
  }, [emptyMessageContainerApi]);

  useEffect(() => {
    contentDelayApi.start({ to: { opacity: 1 }, delay: 500 });
  }, [contentDelayApi]);

  const loadingMessage = loadingMessages[messageIndex];
  return (
    <div className="cw-flex-col cw-items-center">
      <animated.div
        style={emptyMessageContainer}
        className="cw-body-sm cw-text-13"
        data-chromatic="ignore"
        dangerouslySetInnerHTML={{ __html: loadingMessage }}
      />
      <animated.div style={contentDelay} className="cw-flex-col cw-justify-start">
        <Skeleton
          variant="rect"
          width={"60%"}
          height={16}
          style={{ borderRadius: 100 }}
          className="cw-my-2 cw-bg-neutral-inset"
        />
        <Skeleton
          variant="rect"
          width={"90%"}
          height={16}
          style={{ borderRadius: 100 }}
          className="cw-my-2 cw-bg-neutral-inset"
        />
        <Skeleton
          variant="rect"
          width={"75%"}
          height={16}
          style={{ borderRadius: 100 }}
          className="cw-my-2 cw-bg-neutral-inset"
        />
      </animated.div>
    </div>
  );
};
